import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadInstalmentPlanTemplates, deleteInstalmentPlanTemplate } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';

class InstalmentPlanTemplates extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleDelete(id) {
		const { deleteInstalmentPlanTemplate } = this.props;
		deleteInstalmentPlanTemplate(id, () => this.reloadData());
	}

	render() {
		const { isReadonly } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading}/>
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} onDelete={this.handleDelete} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { instalmentPlanTemplates },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const instalmentPlanTemplatesPagination = pagination.instalmentPlanTemplates.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: instalmentPlanTemplatesPagination.ids.map(id => instalmentPlanTemplates[id]),
		pagination: instalmentPlanTemplatesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'InstalmentPlans')
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadInstalmentPlanTemplates,
	deleteInstalmentPlanTemplate,
	initializeFilter: (data, fields) => initialize('instalmentPlanTemplatesFilter', data, fields)
})(InstalmentPlanTemplates);